import { CaseSummaryFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";

import {
  fakeEntreprise,
  fakeExpertComptable,
  fakePaperDocument,
  fakeRepresentantlegal,
} from "./fakeElement";
import { fakeProperties } from "./fakeProperties";

export const fakeCaseSummaryCurrent: CaseSummaryFragmentFragment = {
  __typename: "Case",
  id: "Q2FzZTo5NzVlMDFkYy1lZDUyLTRjMTAtYTkxNC1jMWMzMDgxYTJiOGE=",
  typeCode: "Demande",
  snapshotCreation: null,
  lastScore: 10.0,
  properties: fakeProperties("current", "2025-08-20T10:15:30.000Z", "Current", "1000"),
  elements: [
    fakeEntreprise("12345"),
    fakeExpertComptable("Current", "version", "current.version@gmail.com"),
    fakeRepresentantlegal("current", "version", "current.version@gmail.com"),
    fakePaperDocument("current"),
  ],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};

export const fakeCaseSummaryCreation: CaseSummaryFragmentFragment = {
  __typename: "Case",
  id: "case2",
  typeCode: "Demande",
  lastScore: 85,
  snapshotCreation: "2025-08-19T10:15:30.000Z",
  properties: fakeProperties("creation", "2025-08-19T10:15:30.000Z", "Creation", "2000"),
  elements: [
    fakeEntreprise("4567"),
    fakeExpertComptable("Creation", "version", "creation.version@gmail.com"),
    fakeRepresentantlegal("creation", "version", "creation.version@gmail.com"),
    fakePaperDocument("creation"),
  ],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};

export const fakeCaseSummaryValidation: CaseSummaryFragmentFragment = {
  __typename: "Case",
  id: "case3",
  typeCode: "Demande",
  lastScore: 90,
  snapshotCreation: "2025-08-21T10:15:30.000Z",
  properties: fakeProperties("validation", "2025-08-21T10:15:30.000Z", "Validation", "3000"),
  elements: [
    fakeEntreprise("7890"),
    fakeExpertComptable("Validation", "version", "validation.version@gmail.com"),
    fakeRepresentantlegal("validation", "version", "validation.version@gmail.com"),
    fakePaperDocument("validation"),
  ],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};

// Export default for backwards compatibility
export const fakeCaseSummary = fakeCaseSummaryCreation;
